import { render, staticRenderFns } from "./lobbyGC.vue?vue&type=template&id=11892d78"
import script from "./lobbyGC.vue?vue&type=script&lang=js"
export * from "./lobbyGC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports